import LabReport from "../lab/LLPLForm";
import EmpDashboard from "../pages/employeerole/EmpDashboard";
import EmpPage from "../pages/employeerole/EmpPage";
import EmpProjects from "../pages/employeerole/EmpProjects";
import { ProjectDashboard } from "../pages/project/ProjectDashboard";
import ViewProject from "../pages/project/ViewProject";
import { Quotationmanage, QuotationSlip } from "../pages/Quatations/QuatationManagement";
import Forgotpassword from "../pages/website/Forgotpassword";
import Login from "../pages/website/Login";
import Resetpassword from "../pages/website/Resetpassword";


export const routingData = [

  {
    role: "",
    isProtected: false,
    defaultRoute: "/",
    routes: [
      {
        path: "",
        component: <Login />,
      },
      {
        path: "login",
        component: <Login />,
      },
      {
        path: "forgotpassword/",
        component: <Forgotpassword />,
      },
      {
        path: "resetpassword/:uidb64/:token/",
        component: <Resetpassword />,
      },
    
     
     
    ],
  },
{
    role: "Employee",
    isProtected: true,
    defaultRoute: "emp/dashboard",

    nestedRoutes: [
      {
        routes: [
          {
            path: "dashboard",              // fixed: was "/"
            component: <ProjectDashboard />,
          },
          {
            path: "projects",              // fixed: was "/"
            component: <ViewProject />,
          },
           {
            path: "quotationmanagement",
            component: <Quotationmanage />,
          },
           {
            path: "labAutomation",
            component: <LabReport />,
          },

           {
            path: "quotationSlip/:id/",
            component: <QuotationSlip />,
          },
        ],
        path: "emp",
        component: <EmpPage />,
      },
    ],
    
},
{
    role: "Account",
    isProtected: true,
    defaultRoute: "account/dashboard",

    nestedRoutes: [
      {
        routes: [
          {
            path: "dashboard",              // fixed: was "/"
            component: <ProjectDashboard />,
          },
          {
            path: "projects",              // fixed: was "/"
            component: <ViewProject />,
          },
        ],
        path: "emp",
        component: <EmpPage />,
      },
    ],
},
]
